import script from "./DashboardAi.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAi.vue?vue&type=script&setup=true&lang=js"

import "./DashboardAi.vue?vue&type=style&index=0&id=d3135f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3135f16"]])

export default __exports__